import { useState } from "react";
import GiftcardsList from "./components/GiftCardsList/GiftcardsList";
import { GiftcardsListingProvider } from "./context/GiftcardsListingContext";
import Filters from "./components/Filters/Filters";
import GiftcardsSearch from "./components/GiftcardsSearch/GiftcardsSearch";
import Sorters from "./components/Sorters/Sorters";
import GiftcardsHero from "./components/GiftcardsHero/GiftcardsHero";
import "./GiftcardsListing.css";

export default function GiftcardsListing() {
  const [filters, setFilters] = useState({});
  return (
    <GiftcardsListingProvider value={{ filters, setFilters }}>
      <div className="bg-background-minimal flex h-full flex-col gap-4">
        <div className="relative isolate flex w-full flex-col gap-5 px-5 pt-10 md:px-20 md:pt-10 giftcards-listing-gradient">
          <GiftcardsHero />
          <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
            <div className="md:w-100 w-full">
              <GiftcardsSearch name="name" />
            </div>
            <div className="flex items-stretch gap-2">
              <div className="flex flex-1 md:flex-none">
                <Sorters />
              </div>
              <div>
                <Filters />
              </div>
            </div>
          </div>
        </div>
        <div className="flex w-full flex-col gap-4 px-5 pb-10 md:px-20">
          <GiftcardsList />
        </div>
      </div>
    </GiftcardsListingProvider>
  );
}
